import { GetLicensedProductsQueryVariables } from '@app/data/shop-bff';
import { publicShopBffSdk } from '@app/utils/common';
import { useCallback, useState } from 'react';
import { LicensedProduct } from 'types/shop-bff/types';

export const useLicensedProducts = () => {
  const [{ licensedProducts, loading }, setLicensedProducts] = useState<{
    licensedProducts: LicensedProduct[];
    loading: boolean;
  }>({
    licensedProducts: [],
    loading: true,
  });

  const refresh = useCallback(
    (variables: GetLicensedProductsQueryVariables) => {
      setLicensedProducts({ licensedProducts: [], loading: true });

      publicShopBffSdk
        .GetLicensedProducts(variables)
        .then((res) => {
          setLicensedProducts({
            licensedProducts: res.shop_licensedInventoryItems.results || [],
            loading: false,
          });
        })
        .catch(() => {
          // TODO: Handle errors
          setLicensedProducts({
            licensedProducts: [],
            loading: false,
          });
        });
    },
    []
  );

  return {
    licensedProducts,
    loading,
    refresh,
  };
};
